import { createStore } from 'vuex'
import global from './Global.js'



export const store = createStore({
  modules : {
    global,
  },

  state () {
    return {
    }
  },

  getters : {

  },

  mutations: {

  }
})
